import { FC } from "react"

import { Table } from "@/components/_Shared/Table"
import { Resource } from "@/constants/permission"

import { authorityLogsColumns } from "./AuthorityLogsColumns"

import { useAuthorityLogsQuery } from "@/hook/Authorities/useAuthoritiesPageQuery"
import { useTable } from "@/hook/useTable"

import { AUTHORITY_LOGS_KEY } from "@/types/IAuthorities"

import { getInitialColumns } from "@/utils/getInitialColumns"


const AuthorityLogsPage: FC = () => {
  const { columns, pagination, order, filter } = useTable({
    initialColumns: getInitialColumns(authorityLogsColumns, AUTHORITY_LOGS_KEY),
    key: AUTHORITY_LOGS_KEY
  })

  const { data, isLoading } = useAuthorityLogsQuery({
    Page: pagination.page,
    PageSize: pagination.pageSize,
    Filter: filter.filter,
    OrderBy: order.orderBy
  })

  return (
    <>
      <Table
        tableTitle="Логи выгрузки доверенностей"
        dataSource={data?.response.data}
        columns={columns.data}
        rowKey="id"
        isLoading={isLoading}
        onUpdateColumns={columns.onColumnChange}
        pagination={{
          currentPage: pagination.page,
          pageSize: pagination.pageSize,
          total: data?.response.count,
          onPageChange: pagination.onPageChange,
          onPageSizeChange: pagination.onPageSizeChange
        }}
        onSorterChange={order.setOrderBy}
        permission={{
          resource: Resource.Authorities
        }}
      />
    </>
  )
}

export default AuthorityLogsPage